<template>
  <el-dialog title="创建账号" :visible.sync="visible" width="430px" append-to-body :close-on-click-modal="false" :close-on-press-escape="true" :show-close="true">
    <p class="store-setup-note">当前账号还不是会员，请先完成会员激活后继续使用。</p>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" @keyup.enter.native="submit">
      <el-form-item label="账号名称" prop="name"><el-input v-model.trim="form.name" prefix-icon="el-icon-office-building" maxlength="80" placeholder="请输入账号名称" /></el-form-item>
      <el-form-item label="卡密" prop="cdkey"><el-input v-model.trim="form.cdkey" prefix-icon="el-icon-key" maxlength="100" placeholder="请输入账号卡密" /></el-form-item>
    </el-form>
    <span slot="footer"><el-button type="primary" :loading="loading" @click="submit">创建并进入</el-button></span>
  </el-dialog>
</template>

<script>
import { createStore, getStoreList } from '@/api/content';
import { clearStoreId, getStoreId, setStoreId } from '@/utils/business-context';

export default {
  name: 'StoreSetupDialog',
  data() {
    return {
      visible: false,
      loading: false,
      checking: false,
      checkedToken: '',
      form: { name: '', cdkey: '' },
      rules: {
        name: [{ required: true, message: '请输入账号名称', trigger: 'blur' }],
        cdkey: [{ required: true, message: '请输入账号卡密', trigger: 'blur' }]
      }
    };
  },
  computed: {
    token() {
      return this.$store.state.user.token || '';
    },
    defaultName() {
      const user = this.$store.state.user.userInfo || {};
      return user.name || user.username || '我的账号';
    }
  },
  watch: {
    token: {
      immediate: true,
      handler() {
        this.ensureStore();
      }
    },
    '$route.path'() {
      this.ensureStore();
    }
  },
  created() {
    window.addEventListener('open-store-setup', this.openDialog);
  },
  beforeDestroy() {
    window.removeEventListener('open-store-setup', this.openDialog);
  },
  methods: {
    normalizeStores(data) {
      if (Array.isArray(data)) return data;
      return data && Array.isArray(data.list) ? data.list : [];
    },
    openDialog() {
      if (!this.token || getStoreId()) return;
      if (!this.form.name) this.form.name = this.defaultName;
      this.visible = true;
    },
    async ensureStore() {
      if (!this.token || this.$route.path === '/login' || this.$route.path === '/404' || this.checking || this.checkedToken === this.token) return;
      this.checking = true;
      this.checkedToken = this.token;
      try {
        const stores = this.normalizeStores(await getStoreList());
        if (stores.length) {
          const currentId = getStoreId();
          const firstId = Number(stores[0].storeId || stores[0].id);
          if (!currentId && firstId) setStoreId(firstId);
          return;
        }
        clearStoreId();
        this.form = { name: this.defaultName, cdkey: '' };
        this.visible = true;
      } catch (error) {
        this.checkedToken = '';
      } finally {
        this.checking = false;
      }
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid || this.loading) return;
        this.loading = true;
        try {
          const result = await createStore(this.form);
          let storeId = Number(result && (result.storeId || result.id));
          if (!storeId) {
            const stores = this.normalizeStores(await getStoreList());
            storeId = Number(stores[0] && (stores[0].storeId || stores[0].id));
          }
          if (!storeId) throw new Error('账号创建成功但未获取到账号编号，请刷新后重试');
          setStoreId(storeId);
          this.checkedToken = this.token;
          this.visible = false;
          this.$message.success('账号创建成功');
        } catch (error) {
          this.$message.error(error.message || '账号创建失败');
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.store-setup-note {
  margin: 0 0 16px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.6;
}
</style>
